module.exports = __webpack_public_path__ + "static/media/r315.dc9e1081.jpg";